import { isAndroid, isIOS, isMobile } from 'react-device-detect';
import { SITE_ORIGIN } from '../constants/categorySeoSlugs';
import { DeepLinkDefaultLink } from './deepLinkUtils';

export const SOUNDPILL_OPEN_PAGE_URL = `${SITE_ORIGIN}/open-soundpill`;

export const SOUNDPILL_IOS_APP_STORE =
  'https://apps.apple.com/kr/app/%EC%82%AC%EC%9A%B4%EB%93%9C%ED%95%84/id6450494947';

export const SOUNDPILL_ANDROID_PLAY_STORE =
  'https://play.google.com/store/apps/details?id=info.digitalnutrition.soundpill2&hl=ko-KR';

const ANDROID_PACKAGE = 'info.digitalnutrition.soundpill2';
const APP_SCHEME = 'soundpill';
const APP_OPEN_FALLBACK_MS = 1800;

function openWithStoreFallback(appLink: string, storeUrl: string) {
  let fallbackTimer = window.setTimeout(() => {
    if (document.visibilityState === 'visible') {
      window.location.href = storeUrl;
    }
  }, APP_OPEN_FALLBACK_MS);

  const onVisibilityChange = () => {
    if (document.visibilityState === 'hidden') {
      window.clearTimeout(fallbackTimer);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    }
  };

  document.addEventListener('visibilitychange', onVisibilityChange);
  window.location.href = appLink;
}

/** 앱 있으면 실행, 없으면 notInstalledUrl(스토어/스마트링크) */
export function openAppOrStore(notInstalledUrl: string) {
  if (isAndroid) {
    const fallback = encodeURIComponent(notInstalledUrl);
    window.location.href = `intent://open#Intent;scheme=${APP_SCHEME};package=${ANDROID_PACKAGE};S.browser_fallback_url=${fallback};end`;
    return;
  }

  if (isIOS) {
    openWithStoreFallback(`${APP_SCHEME}://open`, notInstalledUrl);
    return;
  }

  window.location.href = notInstalledUrl;
}

/** Android: 앱 intent → 미설치 시 Play Store (browser_fallback_url) */
function openAndroidAppOrStore() {
  openAppOrStore(SOUNDPILL_ANDROID_PLAY_STORE);
}

/** iOS: 스마트링크/커스텀 스킴 → 미설치·미실행 시 App Store */
function openIosAppOrStore() {
  openWithStoreFallback(DeepLinkDefaultLink, SOUNDPILL_IOS_APP_STORE);
}

/** 모바일: 앱 실행 시도 → 스토어 폴백 / 데스크톱: 웹 홈 */
export function openSoundPillApp(webFallback = '/app/home') {
  if (isAndroid) {
    openAndroidAppOrStore();
    return;
  }

  if (isIOS) {
    openIosAppOrStore();
    return;
  }

  if (isMobile) {
    window.location.href = DeepLinkDefaultLink;
    return;
  }

  window.location.href = webFallback;
}
